import { Component, OnInit, OnDestroy, OnChanges, Output,Input, ViewChild, AfterContentInit, EventEmitter } from '@angular/core';
import { BarcodeDecoderService } from "../services/barcode-decoder.service";
import { BarcodeValidatorService } from "../services/barcode-validator.service";
import { Subject } from "rxjs/Subject";


@Component({
  selector: 'app-media-stream',
  templateUrl: './media-stream.component.html',
  styleUrls: ['./media-stream.component.scss']
})
export class MediaStreamComponent implements OnInit, OnDestroy, AfterContentInit {

  lastResult: any;
  message: any;
  error: any;
  isPlay = true;
  // scanner: boolean = true;

  code$ = new Subject<any>();
  @Input() isMultiMode;
  @ViewChild('interactive') interactive;
  @Output() codeDetected = new EventEmitter();
  @Output() closeCamera = new EventEmitter();
  constructor(private decoderService: BarcodeDecoderService, private barcodeValidator: BarcodeValidatorService) { };

  ngOnInit() {
    // this.logService.printLog("isMultiMode -", this.isMultiMode);
    this.scanBarCode();
  }

  scanBarCode() {
    this.decoderService.onLiveStreamInit();
    this.decoderService.onDecodeProcessed();
    this.decoderService
      .onDecodeDetected()
      .then(code => {
        this.lastResult = code;
        // this.logService.printLog("scan code -", this.lastResult);
        this.decoderService.onPlaySound();
        this.code$.next(code);
        // this.scanner = false;
        // this.logService.printLog('result', this.lastResult);
        this.codeDetected.emit(this.lastResult);
        this.decoderService.onDecodeStop();
        this.checkMultiMode();
      })
      .catch((err) => this.error = `Something Wrong: ${err}`);

    this.barcodeValidator
      .doSearchbyCode(this.code$)
      .subscribe(
        res => this.message = res,
        err => {
          this.message = `An Error! ${err.json().error}`
        }
      );
  }

  checkMultiMode() {
    if (this.isMultiMode) {
      this.scanBarCode();
    }
  }
  closeCam() {
    this.closeCamera.emit(true);
  }
  pauseCam() {
    this.decoderService.onDecodeStop();
    this.isPlay = false;
  }
  playCam() {
    this.decoderService.onLiveStreamInit();
    this.decoderService.onDecodeProcessed();
    this.isPlay = true;
  }
  ngAfterContentInit() {
    this.interactive.nativeElement.children[0].style.position = 'absolute';
  }

  ngOnDestroy() {
    this.decoderService.onDecodeStop();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/barcode/media-stream/media-stream.component.ts